// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import Sidebar from "../common/Sidebar";
// import { useNavigate } from "react-router-dom";
// import "./ManagerLeaveRequests.css";

// const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

// const LeaveRequestsList = () => {
//   const [leaveRequests, setLeaveRequests] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterStatus, setFilterStatus] = useState("all");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchLeaveRequests = async () => {
//       setLoading(true);
//       setError(""); // Clear any previous errors

//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           setError("User not authenticated");
//           return;
//         }

//         const response = await fetch(
//           `${BASE_URL}/api/leave/getmanagerleaverequest`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.message || "Error fetching leave requests");
//         }

//         const data = await response.json();
//         setLeaveRequests(data.leaveRequests || []);
//       } catch (err) {
//         // Only set error if it's not a 404 or empty response
//         if (err.message !== "No leave requests found") {
//           // console.error("Failed to fetch leave requests:", err);
//           // setError("Failed to fetch leave requests");
//         } else {
//           setLeaveRequests([]); // Ensure leaveRequests is empty
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchLeaveRequests();
//   }, [navigate]);

//   const handleStatusChange = async (id, newStatus) => {
//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("User not authenticated");
//         return;
//       }

//       const response = await axios.put(
//         `${BASE_URL}/api/leave/updateLeaveStatus/${id}`,
//         { status: newStatus },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         setLeaveRequests((prevRequests) =>
//           prevRequests.map((request) =>
//             request._id === id ? { ...request, status: newStatus } : request
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Failed to update status:", error);
//       setError(error.response?.data?.message || "Failed to update status");
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "approved":
//         return "status-approved";
//       case "rejected":
//         return "status-rejected";
//       default:
//         return "status-pending";
//     }
//   };

//   const filteredRequests = leaveRequests.filter((request) => {
//     const matchesSearch =
//       request.employee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       request.employee.employeeid
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase());
//     const matchesStatus =
//       filterStatus === "all" || request.status === filterStatus;
//     return matchesSearch && matchesStatus;
//   });

//   const formatDate = (dateString) => {
//     const options = { day: "numeric", month: "short", year: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   return (
//     <div className="manager-dashboard">
//       <Navbar />
//       <div className="manager-container">
//         <Sidebar />
//         <main className="manager-content">
//           <div className="leave-requests-container">
//             <div className="leave-requests-header">
//               <h2 className="leave-requests-title">Employee Leave Requests</h2>

//               <div className="leave-requests-controls">
//                 <div className="search-filter-container">
//                   <div className="search-box">
//                     <i className="fas fa-search"></i>
//                     <input
//                       type="text"
//                       placeholder="Search by name or ID..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                   <div className="filter-dropdown">
//                     <select
//                       value={filterStatus}
//                       onChange={(e) => setFilterStatus(e.target.value)}
//                     >
//                       <option value="all">All Status</option>
//                       <option value="pending">Pending</option>
//                       <option value="approved">Approved</option>
//                       <option value="rejected">Rejected</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {error && <div className="alert alert-error">{error}</div>}

//             {loading ? (
//               <div className="loading-container">
//                 <div className="loading-spinner"></div>
//                 <p>Loading leave requests...</p>
//               </div>
//             ) : filteredRequests.length === 0 ? (
//               <div className="empty-state">
//                 {/* <img src="/images/no-data.svg" alt="No leave requests" /> */}
//                 <h3>No leave requests found</h3>
//                 <p>
//                   There are currently no leave requests matching your criteria
//                 </p>
//               </div>
//             ) : (
//               <>
//                 {error && <div className="alert alert-error">{error}</div>}
//                 <div className="leave-requests-table-container">
//                   <table className="leave-requests-table">
//                     <thead>
//                       <tr>
//                         <th>Employee</th>
//                         <th>Leave Type</th>
//                         <th>Date Range</th>
//                         <th>Reason</th>
//                         <th>Status</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filteredRequests.map((request) => (
//                         <tr key={request._id}>
//                           <td>
//                             <div className="employee-info">
//                               <div className="employee-avatar">
//                                 {request.employee.name.charAt(0).toUpperCase()}
//                               </div>
//                               <div className="employee-details">
//                                 <span className="employee-name">
//                                   {request.employee.name}
//                                 </span>
//                                 <span className="employee-id">
//                                   ID: {request.employee.employeeid}
//                                 </span>
//                               </div>
//                             </div>
//                           </td>
//                           <td className="leave-type">{request.leaveType}</td>
//                           <td className="date-range">
//                             <div className="date-range-container">
//                               <span className="date">
//                                 {formatDate(request.startDate)}
//                               </span>
//                               <span className="date-separator">to</span>
//                               <span className="date">
//                                 {formatDate(request.endDate)}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="leave-reason">
//                             <div className="reason-text">{request.reason}</div>
//                           </td>
//                           <td>
//                             <span
//                               className={`status-badge ${getStatusColor(
//                                 request.status
//                               )}`}
//                             >
//                               {request.status}
//                             </span>
//                           </td>
//                           <td>
//                             <select
//                               className={`status-select ${request.status}`}
//                               value={request.status}
//                               onChange={(e) =>
//                                 handleStatusChange(request._id, e.target.value)
//                               }
//                             >
//                               <option value="pending">Pending</option>
//                               <option value="approved">Approve</option>
//                               <option value="rejected">Reject</option>
//                             </select>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Mobile Cards View */}
//                 <div className="leave-requests-cards">
//                   {filteredRequests.map((request) => (
//                     <div key={request._id} className="leave-card">
//                       <div className="card-header">
//                         <div className="employee-info">
//                           <div className="employee-avatar">
//                             {request.employee.name.charAt(0).toUpperCase()}
//                           </div>
//                           <div className="employee-details">
//                             <span className="employee-name">
//                               {request.employee.name}
//                             </span>
//                             <span className="employee-id">
//                               ID: {request.employee.employeeid}
//                             </span>
//                           </div>
//                         </div>
//                         <span
//                           className={`status-badge ${getStatusColor(
//                             request.status
//                           )}`}
//                         >
//                           {request.status}
//                         </span>
//                       </div>

//                       <div className="card-body">
//                         <div className="card-row">
//                           <span className="card-label">Leave Type:</span>
//                           <span className="card-value">
//                             {request.leaveType}
//                           </span>
//                         </div>
//                         <div className="card-row">
//                           <span className="card-label">Date Range:</span>
//                           <span className="card-value">
//                             {formatDate(request.startDate)} to{" "}
//                             {formatDate(request.endDate)}
//                           </span>
//                         </div>
//                         <div className="card-row">
//                           <span className="card-label">Reason:</span>
//                           <span className="card-value reason-text">
//                             {request.reason}
//                           </span>
//                         </div>
//                       </div>

//                       <div className="card-footer">
//                         <select
//                           className={`status-select ${request.status}`}
//                           value={request.status}
//                           onChange={(e) =>
//                             handleStatusChange(request._id, e.target.value)
//                           }
//                         >
//                           <option value="pending">Pending</option>
//                           <option value="approved">Approve</option>
//                           <option value="rejected">Reject</option>
//                         </select>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>
//         </main>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default LeaveRequestsList;



















import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";
import {
  Box,
  Typography,
  InputBase,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Avatar,
} from "@mui/material";
import { TextField, InputAdornment } from "@mui/material";

import { useNavigate } from "react-router-dom";
import "./ManagerLeaveRequests.css";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

const LeaveRequestsList = () => {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLeaveRequests = async () => {
      setLoading(true);
      setError(""); // Clear any previous errors

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          setError("User not authenticated");
          return;
        }

        const response = await fetch(
          `${BASE_URL}/api/leave/getmanagerleaverequest`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Error fetching leave requests");
        }

        const data = await response.json();
        setLeaveRequests(data.leaveRequests || []);
      } catch (err) {
        // Only set error if it's not a 404 or empty response
        if (err.message !== "No leave requests found") {
          // console.error("Failed to fetch leave requests:", err);
          // setError("Failed to fetch leave requests");
        } else {
          setLeaveRequests([]); // Ensure leaveRequests is empty
        }
      } finally {
        setLoading(false);
      }
    };

    fetchLeaveRequests();
  }, [navigate]);

  const handleStatusChange = async (id, newStatus) => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("User not authenticated");
        return;
      }

      const response = await axios.put(
        `${BASE_URL}/api/leave/updateLeaveStatus/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setLeaveRequests((prevRequests) =>
          prevRequests.map((request) =>
            request._id === id ? { ...request, status: newStatus } : request
          )
        );
      }
    } catch (error) {
      console.error("Failed to update status:", error);
      setError(error.response?.data?.message || "Failed to update status");
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      default:
        return "status-pending";
    }
  };

  const filteredRequests = leaveRequests.filter((request) => {
    const employeeName = request?.employee?.name || "";
    const employeeCode = request?.employee?.employeeid || "";
    const matchesSearch =
      employeeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employeeCode.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus =
      filterStatus === "all" || request.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const getSubmissionTimestamp = (request) => {
    if (request?.createdAt) {
      const createdAtMs = new Date(request.createdAt).getTime();
      if (!Number.isNaN(createdAtMs)) return createdAtMs;
    }

    // Fallback for schemas without timestamps: ObjectId contains creation time.
    const objectId = request?._id;
    if (typeof objectId === "string" && objectId.length >= 8) {
      const hexSeconds = objectId.substring(0, 8);
      const seconds = parseInt(hexSeconds, 16);
      if (!Number.isNaN(seconds)) return seconds * 1000;
    }

    return 0;
  };

  const sortedFilteredRequests = [...filteredRequests].sort(
    (a, b) => getSubmissionTimestamp(b) - getSubmissionTimestamp(a)
  );

  const formatDate = (dateString) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "#F8FAFC" }}>
      <Navbar />
      <Box sx={{ display: "flex", flex: 1 }}>
        <Sidebar />
        <Box
          sx={{
            flex: 1,
            p: { xs: 3, md: 2 },
            ml: { md: "10px" },
            mt: 4, // top margin added

            transition: "margin-left 0.3s ease",
          }}
        >

          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              rowGap: 2,
              mb: 1,
              mt: 5,
            }}
          >
            {/* Left side: Title and Subtitle */}
            <Box>
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                Employee Leave Requests
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Manage and view all active employees
              </Typography>
            </Box>


            {/* Right side: Search + Filter */}
            {/* <Box sx={{ mb: 4 }}>

              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 3 }}>
                <Box
                  sx={{
                    position: "relative",
                    flex: 1,
                    minWidth: 250,
                  }}
                >
                  <Box
                    component="i"
                    className="fas fa-search"
                    sx={{
                      position: "absolute",
                      left: 12,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#95a5a6",
                    }}
                  />
                  <InputBase
                    placeholder="Search by name or ID..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{
                      width: "100%",
                      pl: 4,
                      py: 1,
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      fontSize: "0.9rem",
                      bgcolor: "white",
                      "&:focus-within": {
                        borderColor: "#3498db",
                        boxShadow: "0 0 0 3px rgba(52,152,219,0.1)",
                      },
                    }}
                  />
                </Box>
                <Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  sx={{
                    minWidth: 180,
                    borderRadius: "8px",
                    fontSize: "0.9rem",
                    bgcolor: "white",
                    "& fieldset": { border: "1px solid #ddd" },
                    "&.Mui-focused fieldset": { borderColor: "#3498db" },
                  }}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="approved">Approved</MenuItem>
                  <MenuItem value="rejected">Rejected</MenuItem>
                </Select>
              </Box>
            </Box> */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {/* Search Input */}
                <TextField
                  placeholder="Search by name or ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <i
                          className="fas fa-search"
                          style={{ color: "#A0A4A8", fontSize: 16 }}
                        />
                      </InputAdornment>
                    ),
                    sx: {
                      height: 38,
                      paddingLeft: 1,
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                    },
                  }}
                  sx={{
                    width: 290,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "5px",
                      backgroundColor: "#fff",
                      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
                      "& fieldset": {
                        border: "1px solid #ccc",
                      },
                    },
                    "& input": {
                      fontSize: 14,
                      padding: "8px 0",
                      color: "#64748B",
                    },
                    "& input::placeholder": {
                      color: "#64748B",
                      opacity: 1,
                    },
                  }}
                />

                {/* Filter Dropdown */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    px: 2,
                    height: 38,
                    width: 230,
                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.05)",
                    overflow: "hidden",
                    "& .MuiSelect-select": {
                      paddingRight: "24px !important",
                    },
                  }}
                >
                  <i
                    className="fas fa-filter"
                    style={{ color: "#A0A4A8", marginRight: 8, fontSize: 14 }}
                  />

                  <Select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    displayEmpty
                    variant="standard"
                    disableUnderline
                    fullWidth
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: 2,
                          mt: 1,
                        },
                      },
                    }}
                    sx={{
                      fontSize: 14,
                      color: "#64748B",
                      "&:focus": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <MenuItem value="all">All Status</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                  </Select>
                </Box>
              </Box>
            </Box>

          </Box>



          {/* Error */}
          {error && (
            <Box sx={{ p: 2, borderRadius: 1, mb: 3, bgcolor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb" }}>
              {error}
            </Box>
          )}

          {/* Loading */}
          {loading ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 6 }}>
              <Box
                sx={{
                  border: "4px solid rgba(0,0,0,0.1)",
                  borderTop: "4px solid #5C85FF",
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  animation: "spin 1s linear infinite",
                  mb: 2,
                  "@keyframes spin": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />
              <Typography>Loading leave requests...</Typography>
            </Box>
          ) : sortedFilteredRequests.length === 0 ? (
            <Paper sx={{ p: 4, textAlign: "center", borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                No leave requests found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                There are currently no leave requests matching your criteria
              </Typography>
            </Paper>
          ) : (
            <>
              {/* Table view (desktop) */}
              {/* <TableContainer
                component={Paper}
                sx={{
                  display: { xs: "none", lg: "block" },
                  borderRadius: 2,
                  overflow: "hidden",
                  boxShadow: "none", // removes Paper shadow
                  border: "none", // removes Paper border
                  "& .MuiTable-root": {
                    borderCollapse: "collapse", // ensures no spacing/border
                  },
                }}
              >
                <Table
                  sx={{
                    "& .MuiTableCell-root": {
                      border: "none", // removes cell borders
                    },
                    "& .MuiTableRow-root": {
                      border: "none", // removes row borders
                    },
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#3b82f6" }}>
                      {["Employee", "Leave Type", "Date Range", "Reason", "Status", "Action"].map((head) => (
                        <TableCell key={head} sx={{ color: "white", fontWeight: 600 }}>
                          {head}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedFilteredRequests.map((request) => (
                      <TableRow
                        key={request._id}
                        sx={{
                          "&:hover": { bgcolor: "#f8f9fa" },
                        }}
                      >
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Avatar sx={{ bgcolor: "#3498db" }}>
                              {request.employee.name.charAt(0).toUpperCase()}
                            </Avatar>
                            <Box>
                              <Typography sx={{ fontWeight: 500 }}>{request.employee.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                ID: {request.employee.employeeid}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>{request.leaveType}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
                            <Typography sx={{ fontWeight: 500 }}>{formatDate(request.startDate)}</Typography>
                            <Typography variant="caption" color="text.secondary" align="center">
                              to
                            </Typography>
                            <Typography sx={{ fontWeight: 500 }}>{formatDate(request.endDate)}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis" }}>
                          {request.reason}
                        </TableCell>
                        <TableCell>
                          <Box
                            component="span"
                            sx={{
                              px: 1.5,
                              py: 0.5,
                              borderRadius: "20px",
                              fontSize: "0.8rem",
                              fontWeight: 500,
                              textTransform: "capitalize",
                              bgcolor:
                                request.status === "pending"
                                  ? "#fff3cd"
                                  : request.status === "approved"
                                    ? "#d4edda"
                                    : "#f8d7da",
                              color:
                                request.status === "pending"
                                  ? "#856404"
                                  : request.status === "approved"
                                    ? "#155724"
                                    : "#721c24",
                            }}
                          >
                            {request.status}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Select
                            value={request.status}
                            onChange={(e) => handleStatusChange(request._id, e.target.value)}
                            sx={{
                              minWidth: 120,
                              bgcolor:
                                request.status === "pending"
                                  ? "#fff3cd"
                                  : request.status === "approved"
                                    ? "#d4edda"
                                    : "#f8d7da",
                            }}
                          >
                            <MenuItem value="pending">Pending</MenuItem>
                            <MenuItem value="approved">Approve</MenuItem>
                            <MenuItem value="rejected">Reject</MenuItem>
                          </Select>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer> */}

              <Box
                sx={{
                  maxWidth: "100%",
                  width: "100%",
                  mt: 4,
                  mx: "auto",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                  px: { xs: 1.5, sm: 2.5 }, // slightly reduced horizontal padding
                  py: 2, // slightly reduced vertical padding
                  boxShadow: "none",
                  border: "none !important",
                }}
              >
                {/* Heading */}
                <Typography variant="h6" fontWeight={600} gutterBottom fontSize={17}>
                  Leave Management
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  fontSize={13}
                >
                  View, update, and manage employee leave requests efficiently
                </Typography>

                {/* Table */}
                <TableContainer
                  component={Paper}
                  sx={{
                    display: { xs: "none", lg: "block" },
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: "none",
                    border: "none",
                  }}
                >
                  <Table
                    sx={{
                      minWidth: 640, // slightly reduced
                      borderCollapse: "collapse",
                      border: "none !important",
                      outline: "none !important",
                      "& td, & th": {
                        border: "none !important",
                        fontSize: 13.5, // slightly smaller font
                        py: 1.1, // reduced row height
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& th": {
                            borderBottom: "1px solid #e0e0e0",
                            fontWeight: 500,
                            fontSize: 14,
                            py: 1.3,
                          },
                        }}
                      >
                        <TableCell sx={{ width: "22%" }}>Employee</TableCell>
                        <TableCell sx={{ width: "14%" }}>Leave Type</TableCell>
                        <TableCell sx={{ width: "14%" }}>Date Range</TableCell>
                        <TableCell sx={{ width: "26%" }}>Reason</TableCell>
                        <TableCell sx={{ width: "12%" }}>Status</TableCell>
                        <TableCell sx={{ width: "10%" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {sortedFilteredRequests.map((request) => (
                        <TableRow
                          key={request._id}
                          hover
                          sx={{
                            "& td": { borderBottom: "none" },
                            "&:hover": { bgcolor: "#F8FAFC" },
                          }}
                        >
                          {/* Employee */}
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                              <Avatar
                                sx={{
                                  width: 28, // reduced from 30
                                  height: 28,
                                  fontSize: "0.85rem",
                                  bgcolor: "#5C85FF",
                                }}
                              >
                                {(request?.employee?.name || "U").charAt(0).toUpperCase()}
                              </Avatar>
                              <Box>
                                <Typography fontSize={13.5} fontWeight={500}>
                                  {request?.employee?.name || "Unknown Employee"}
                                </Typography>
                                <Typography fontSize={11.5} color="text.secondary">
                                  ID: {request?.employee?.employeeid || "N/A"}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>

                          {/* Leave Type */}
                          <TableCell sx={{ fontSize: 13.5 }}>{request.leaveType}</TableCell>

                          {/* Date Range */}
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 0.25,
                                whiteSpace: "nowrap", // 🚫 Prevent breaking into two lines
                                minWidth: "max-content", // 🔹 Ensure enough width for full date
                                mr: 6,
                              }}
                            >
                              <Typography fontSize={13.5} fontWeight={500} noWrap>
                                {formatDate(request.startDate)}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                fontSize={11}
                                sx={{ lineHeight: 1 }}
                              >
                                to
                              </Typography>
                              <Typography fontSize={13.5} fontWeight={500} noWrap>
                                {formatDate(request.endDate)}
                              </Typography>
                            </Box>
                          </TableCell>



                          {/* Reason */}
                          <TableCell
                            sx={{
                              fontSize: 13.5,
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              maxWidth: 330,
                            }}
                          >
                            {request.reason}
                          </TableCell>

                          {/* Status */}
                          <TableCell>
                            <Box
                              component="span"
                              sx={{
                                px: 1.3,
                                py: 0.45,
                                borderRadius: "8px",
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                textTransform: "capitalize",
                                bgcolor:
                                  request.status === "pending"
                                    ? "#fff3cd"
                                    : request.status === "approved"
                                      ? "#d4edda"
                                      : "#f8d7da",
                                color:
                                  request.status === "pending"
                                    ? "#856404"
                                    : request.status === "approved"
                                      ? "#155724"
                                      : "#721c24",
                              }}
                            >
                              {request.status}
                            </Box>
                          </TableCell>

                          {/* Action */}
                          {/* <TableCell>
                            <Select
                              value={request.status}
                              onChange={(e) => handleStatusChange(request._id, e.target.value)}
                              sx={{
                                minWidth: 110,
                                fontSize: 13,
                                bgcolor:
                                  request.status === "pending"
                                    ? "#fff3cd"
                                    : request.status === "approved"
                                      ? "#d4edda"
                                      : "#f8d7da",
                              }}
                            >
                              <MenuItem value="pending">Pending</MenuItem>
                              <MenuItem value="approved">Approve</MenuItem>
                              <MenuItem value="rejected">Reject</MenuItem>
                            </Select>
                          </TableCell> */}

                        <TableCell>
  <Select
    value={request.status}
    onChange={(e) => handleStatusChange(request._id, e.target.value)}
    displayEmpty
    sx={{
      width: 140, // ✅ fixed width so it doesn't change
      fontSize: 13,
      fontWeight: 500,
      borderRadius: 2,
      px: 0.8,
      height: 32,
      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        gap: 0.6,
        py: 0.4,
      },
      bgcolor:
        request.status === "pending"
          ? "rgba(255, 193, 7, 0.15)"
          : request.status === "approved"
          ? "rgba(40, 167, 69, 0.15)"
          : "rgba(220, 53, 69, 0.15)",
      color:
        request.status === "pending"
          ? "#856404"
          : request.status === "approved"
          ? "#155724"
          : "#721c24",
    }}
    MenuProps={{
      PaperProps: {
        sx: {
          borderRadius: 2,
          minWidth: 140, // ✅ match dropdown width
          "& .MuiMenuItem-root": {
            py: 0.6,
            fontSize: 13,
          },
        },
      },
    }}
  >
    <MenuItem value="pending">⏳ Pending</MenuItem>
    <MenuItem value="approved">✅ Approve</MenuItem>
    <MenuItem value="rejected">❌ Reject</MenuItem>
  </Select>
</TableCell>


                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Mobile cards */}
              <Box sx={{ display: { xs: "grid", lg: "none" }, gap: 2,mt:3 }}>
  {sortedFilteredRequests.map((request) => (
    <Card key={request._id} sx={{ borderRadius: 2 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: "#5C85FF" }}>
            {(request?.employee?.name || "U").charAt(0).toUpperCase()}
          </Avatar>
        }
        title={
          <Typography sx={{ fontWeight: 500 }}>
            {request?.employee?.name || "Unknown Employee"}
          </Typography>
        }
        subheader={`ID: ${request?.employee?.employeeid || "N/A"}`}
        action={
          <Box
            sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: "8px",
              fontSize: "0.8rem",
              fontWeight: 500,
              textTransform: "capitalize",
              bgcolor:
                request.status === "pending"
                  ? "#fff3cd"
                  : request.status === "approved"
                  ? "#d4edda"
                  : "#f8d7da",
              color:
                request.status === "pending"
                  ? "#856404"
                  : request.status === "approved"
                  ? "#155724"
                  : "#721c24",
            }}
          >
            {request.status}
          </Box>
        }
      />
      <CardContent>
        <Typography variant="body2">
          <strong>Leave Type:</strong> {request.leaveType}
        </Typography>
        <Typography variant="body2">
          <strong>Date Range:</strong> {formatDate(request.startDate)} to{" "}
          {formatDate(request.endDate)}
        </Typography>
        <Typography variant="body2">
          <strong>Reason:</strong> {request.reason}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Select
          value={request.status}
          onChange={(e) => handleStatusChange(request._id, e.target.value)}
          displayEmpty
          sx={{
            width: 140, // ✅ fixed width so it doesn’t resize
            fontSize: 13,
            fontWeight: 500,
            borderRadius: 2,
            height: 32,
            px: 0.8,
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              gap: 0.6,
              py: 0.4,
            },
            bgcolor:
              request.status === "pending"
                ? "rgba(255, 193, 7, 0.15)"
                : request.status === "approved"
                ? "rgba(40, 167, 69, 0.15)"
                : "rgba(220, 53, 69, 0.15)",
            color:
              request.status === "pending"
                ? "#856404"
                : request.status === "approved"
                ? "#155724"
                : "#721c24",
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: 2,
                minWidth: 140, // ✅ match select width
                "& .MuiMenuItem-root": {
                  py: 0.6,
                  fontSize: 13,
                },
              },
            },
          }}
        >
          <MenuItem value="pending">⏳ Pending</MenuItem>
          <MenuItem value="approved">✅ Approve</MenuItem>
          <MenuItem value="rejected">❌ Reject</MenuItem>
        </Select>
      </CardActions>
    </Card>
  ))}
</Box>

            </>
          )}
        </Box>
      </Box>
      <Footer />
    </Box>
  );

};

export default LeaveRequestsList;

